import {ElementStyles} from "./ElementStyles";
import {useContext, useEffect, useState} from "react";
import {APIContext} from "../Globals.tsx";

export default function AutoTextInputWeex({
                                            onChange,
                                            value = "afds",
                                            readOnly = false,
                                            placeholder,
                                            rows = 1,
                                            label = null,
                                            light = false,
                                            ...props
                                          }){
  const [suggestions, setSuggestions] = useState([]);
  const [activeSuggestions, setActiveSuggestions] = useState([]);
  const [activeSuggestion, setActiveSuggestion] = useState(0);
  const [value_, setValue_] = useState([value, ""]);
  const [curPos, setCurPos] = useState(null)
  const {getAutoFills} = useContext(APIContext)

  function onSuggestionClick(index){
    const e = { target: {}}
    let autoFill = activeSuggestions[index]
    if(autoFill.includes("#")){
      const inputNumber = prompt("Anzahl eingeben:");
      if(!isNaN(inputNumber) && inputNumber !== null && inputNumber !== ""){
        const numberEntered = Number(inputNumber);
        autoFill = autoFill.replace("#", numberEntered)
      }
      else{
        console.log("Invalid input. Please enter a valid number.");
      }
    }
    const lastIndexBeforeWord = value_[0].lastIndexOf(" ") > value_[0].lastIndexOf("\n")? value_[0].lastIndexOf(" "): value_[0].lastIndexOf("\n")
    e.target.value = value_[0].slice(0, lastIndexBeforeWord + 1) + autoFill + (value_[1].length > 0 ? " " + value_[1]: value_[1])
    onChange(e)
    setActiveSuggestions([])
  }

  function onRemoveSuggestion(e, suggestion){
  }

  //style it: https://react-select.com/styles
  const styles = {
    containerDiv: {
      borderRadius: ElementStyles.borderRadius,
      boxSizing: "inherit",
      background: light ? ElementStyles.color3 : ElementStyles.color2,
      color: ElementStyles.color2,
      padding: ElementStyles.paddingLabels,
      minHeight: ElementStyles.height,
      borderWidth: "2px",
      borderStyle: "solid",
      borderColor: "var(--white)",
      position: "relative"
    },
    input: {
      width: "calc(100%)",
      background: light ? ElementStyles.color3 : ElementStyles.color2,
      color: ElementStyles.color,
      border: "none",
      resize: "none",
      fontSize: 16,
      outline: "none"
    }
  };

  function onChange_(e){
    if(rows === 1){
      e.target.value = e.target.value.replace("\n", "");
      onChange(e);
    }
    else{
      onChange(e);
    }
    getCursorPos()
  }

  useEffect(() => {
    getAutoFills().then(data=>setSuggestions(data))
    //https://dev.to/phuocng/calculate-the-coordinates-of-the-current-cursor-in-a-text-area-cle
    const containerEle = document.getElementById('containerAutoText');
    const textarea = document.getElementById('textarea');
    const mirroredEle = document.createElement('div');
    mirroredEle.id = "mirroredElement"
    mirroredEle.textContent = textarea.value;
    mirroredEle.style.position = "absolute";
    mirroredEle.style.top = "0";
    mirroredEle.style.left = "0";
    mirroredEle.style.height = "100%";
    mirroredEle.style.width = "100%";
    mirroredEle.style.overflow = "hidden";
    mirroredEle.style.color = "transparent";
    containerEle.prepend(mirroredEle);

    const textareaStyles = window.getComputedStyle(textarea);
    [
      'border',
      'boxSizing',
      'fontFamily',
      'fontSize',
      'fontWeight',
      'letterSpacing',
      'lineHeight',
      'padding',
      'textDecoration',
      'textIndent',
      'textTransform',
      'whiteSpace',
      'wordSpacing',
      'wordWrap'
    ].forEach((property) => {
      mirroredEle.style[property] = textareaStyles[property];
    });
    mirroredEle.style.borderColor = 'transparent';

    textarea.addEventListener('scroll', () => {
      mirroredEle.scrollTop = textarea.scrollTop;
    });
  }, []);

  useEffect(() => {
    window.addEventListener("keydown", keyDown)
    return (()=>window.removeEventListener("keydown", keyDown))
  }, [activeSuggestions, activeSuggestion]);

  function keyDown(e){
    if(e.key === "ArrowDown" && activeSuggestions.length){
      setActiveSuggestion(prev => (prev + 1) % activeSuggestions.length);
      e.preventDefault();
    }
    else if(e.key === "ArrowUp" && activeSuggestions.length){
      setActiveSuggestion(prev => (prev - 1 + activeSuggestions.length) % activeSuggestions.length);
      e.preventDefault();
    }
    else if(e.key === "Enter" && activeSuggestions.length){
      onSuggestionClick(activeSuggestion)
      e.preventDefault();
    }
  }



  function getCursorPos(){
    const textarea = document.getElementById("textarea")
    const mirroredEle = document.getElementById("mirroredElement")
    const cursorPos = textarea.selectionStart;
    const textBeforeCursor = textarea.value.substring(0, cursorPos);
    const textAfterCursor = textarea.value.substring(cursorPos);

    const pre = document.createTextNode(textBeforeCursor);
    const post = document.createTextNode(textAfterCursor);
    const caretEle = document.createElement('span');
    caretEle.innerHTML = '&nbsp;';

    mirroredEle.innerHTML = '';
    mirroredEle.append(pre, caretEle, post);

    const rect = caretEle.getBoundingClientRect();
    const rectTA = textarea.getBoundingClientRect();
    setCurPos([rect.left - rectTA.left - 1, rect.bottom - rectTA.top + 1])
    setValue_([textBeforeCursor, textAfterCursor])
    if(textBeforeCursor.length > 1 && /^[a-zA-Z0-9]{2}$/.test(textBeforeCursor.slice(-2))){
      const lastIndexBeforeWord = textBeforeCursor.lastIndexOf(" ") > textBeforeCursor.lastIndexOf("\n")? textBeforeCursor.lastIndexOf(" "): textBeforeCursor.lastIndexOf("\n")
      const suggestions_ = suggestions.filter(s => s.startsWith(textBeforeCursor.slice(lastIndexBeforeWord + 1)));
      setActiveSuggestions(suggestions_);
      setActiveSuggestion(0)
    } else {
      setActiveSuggestions([])
    }
  }

  //https://react.dev/reference/react-dom/components/textarea
  return (
    <div style={styles.containerDiv} {...props} className={"centerVertical"}>
      {label && value && <label style={{
        color: "var(--white)",
        position: "absolute",
        top: -11,
        zIndex: 1,
        left: 10,
        background: light ? ElementStyles.color3 : ElementStyles.color2,
        paddingLeft: 3,
        paddingRight: 3
      }}>{label}</label>}
      <div style={{position: "relative", ...styles.input}} id="containerAutoText">
        <textarea
          id="textarea"
          style={{...styles.input, ...{background: "transparent", position: "relative"}}}
          placeholder={placeholder}
          rows={rows}
          onChange={onChange_}
          value={value}
          readOnly={readOnly}
        />
        {value && curPos && activeSuggestions.length > 0 && (
          <ul style={{
            position: "absolute",
            top: curPos? curPos[1]: 0,
            left: curPos? curPos[0]: 0,
            width: "100%",
            background: light ? ElementStyles.color3 : ElementStyles.color2,
            border: "1px solid var(--white)",
            borderRadius: ElementStyles.borderRadius,
            listStyle: "none",
            margin: 0,
            padding: "5px 0",
            zIndex: 2
          }}>
            {activeSuggestions.map((suggestion, index) => (
              <li
                key={index}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "5px 10px",
                  cursor: "pointer",
                  background: index === activeSuggestion ? ElementStyles.color3 : ElementStyles.color2
                }}
                onClick={() => onSuggestionClick(index)}
                onMouseOver={()=>setActiveSuggestion(index)}
              >
                <span style={{color: "var(--white)"}}>{suggestion}</span>
                {/*<button*/}
                {/*  style={{*/}
                {/*    border: "none",*/}
                {/*    background: "transparent",*/}
                {/*    color: "red",*/}
                {/*    cursor: "pointer"*/}
                {/*  }}*/}
                {/*  onClick={(e) => onRemoveSuggestion(e, suggestion)}*/}
                {/*>*/}
                {/*  R*/}
                {/*</button>*/}
              </li>
            ))}
          </ul>
        )}
      </div>
      {/*<MarkdownPreview markdown={value} />*/}
    </div>
  );
};

